<template>
	<div>
		<h1>Szilenciumi bejegyzések áttekintése és jelenléti ív</h1>
		<v-row>
			<v-col cols="12" sm="2">
				<v-menu
				    v-model="hetfovalaszto.menu"
				    :close-on-content-click="false"
				    transition="scale-transition"
				    offset-y
				    min-width="290px"
				  >
				    <template v-slot:activator="{ on, attrs }">
				      <v-text-field
				        v-model="hetfovalaszto.datum"
				        label="Hét kezdőnapja"
				        prepend-inner-icon="fa-calendar"
				        readonly
				        v-bind="attrs"
				        v-on="on"
				      ></v-text-field>
				    </template>
				    <v-date-picker
				      v-model="hetfovalaszto.datum"
				      no-title
				      scrollable
						  :allowed-dates="hetfok"
							first-day-of-week="1"
							@input="hetfovalaszto.menu=false, tablazatfrissitese()"
				    >
				    </v-date-picker>
			  </v-menu>
			</v-col>
			<v-col cols="12" sm="3">
				<v-select
					v-model="szures.csoportok"
					:items="adatok.csoportok"
					item-text="csoportnev"
					item-value="id"
					multiple
					chips
					label="Csoportok"
					prepend-inner-icon="fa-users"></v-select>
			</v-col>
			<v-col cols="12" sm="3">
				<v-select
					v-model="szures.szobak"
					:items="adatok.szobak"
					item-text="szobanev"
					item-value="id"
					multiple
					label="Szobák"
					chips
					prepend-inner-icon="fa-bed"></v-select>
			</v-col>
			<v-col cols="12" sm="4">
				<v-select
					v-model="szures.szilencium"
					:items="[{szam: 'Mindegyik', id: -1, idopont: '-'}].concat(adatok.szilenciumok)"
					item-text="szam"
					item-value="id"
					label="Szilencium"
					chips
					prepend-inner-icon="fa-business-time">
						<template v-slot:item="{item}">
							{{item.szam=='Mindegyik' ? "Mindegyik szilencium" : (item.szam+". szilencium ("+item.idopont+")")}}
						</template>

				</v-select>
			</v-col>
		</v-row>

    <v-tabs v-model="szures.nap">
        <v-tab>Hétfő</v-tab>
        <v-tab>Kedd</v-tab>
        <v-tab>Szerda</v-tab>
        <v-tab>Csütörtök</v-tab>
    </v-tabs>
		<div v-if="tablazatmutat">

			<v-data-table
				:mobile-breakpoint="0"
				:headers="fejlecekTablazat"
				:items="diakok"
				multi-sort
			>
				<template v-slot:item="{ item }">
					<tr :style="{backgroundColor: !item.szilenciumvalasztas ? 'blue' : (!item.szilenciumiletszambaszamit ? 'green':  'transparent')}">
						<td v-for="(col, index) in fejlecekTablazat" :key="index+''+col">
							<div v-if="col.value === 'nev'" style="text-align: right">
								<v-tooltip top >
									<template v-slot:activator="{on, attrs}">
										<span v-on="on" v-bind="attrs">{{ item[col.value] }}</span>
									</template>
									{{item.minosites}}{{item.csoportnev? " - "+item.csoportnev+" (Csoportvezető: "+item.csoportvezeto+")" : ""}}
								</v-tooltip>
							</div>
							<div v-else-if="col.value==='szoba'" style="text-align: center">
								{{item.szoba}}
							</div>
							<div v-else>
								<div v-if="item.szilenciumvalasztas">
									<v-tooltip top v-if="item[col.value]==-2">
										<template v-slot:activator="{on, attrs}">
											<v-icon color="orange accent-4" v-on="on" v-bind="attrs">fa-user-times</v-icon>
										</template>
										Foglalt {{item["f"+col.value]}}
									</v-tooltip>
									<v-checkbox readonly v-else-if="item[col.value]>=0" :indeterminate="item[col.value]==2" :false-value="1" :true-value="0" @click="jelenletmodositas(item.id,szures.nap,col.value.substring(2))" v-model="item[col.value]" :label="item['t'+col.value]"></v-checkbox>
									<v-icon v-else-if="item[col.value]==-1" color="red accent-4">fa-times</v-icon>

								</div>
								<v-tooltip top v-else>
									<template v-slot:activator="{on, attrs}">
										<v-icon v-on="on" v-bind="attrs" color="yellow accent-2">fa-star</v-icon>
									</template>
									{{item.minosites}} - Szilenciumválasztás alól mentesült
								</v-tooltip>
							</div>
						</td>
					</tr>
				</template>
			</v-data-table>
			<!--<v-data-iterator v-else :items="adatok.szilenciumok" hide-default-footer disable-pagination>
				<template v-slot:item="{item}">
					<v-card>
						<v-card-title>
							{{item.szam}}. szilencium
						</v-card-title>
						<v-card-subtitle>{{item.idopont}}</v-card-subtitle>
						<v-card-text>

						</v-card-text>
					</v-card>
				</template>
			</v-data-iterator>-->
		</div>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
				tablazatmutat: false,
				szures: {
					nap:  new Date().getDay()-1,
					csoportok: [-1],
					szobak: [-1],
					szilencium: -1
				},
				snackbar: {
					megnyit: false,
					szoveg: ""
				},
				hetfovalaszto: {
					menu: false,
					datum: this.aktualishetfo()
				},

				adatok: {}
			}
		},
		computed: {
			fejlecekTablazat() {
				return [{
					text: "Név",
					value: "nev",
					align: "right",
					sortable: true,
					filterable: true,
					groupable: false,
					fixed: true
				},
				{
					text: "Szoba",
					value: "szoba",
					align: "center",
					sortable: true,
					filterable: false,
					groupable: false
				}].concat(this.adatok.szilenciumok.filter(sz => this.szures.szilencium==-1 ? true : sz.id==this.szures.szilencium).map(sz => {return {
					text: sz.szam+". szilencium ("+sz.idopont+")",
					value: "sz"+sz.id,
					align: 'left',
					sortable: false,
					filterable: false,
					groupable: false
				}}))
			},
			diakok() {
				return this.adatok.felhasznalok.filter(f => f.minosites>=0 &&
					(this.szures.szobak.includes(-1) ? true : this.szures.szobak.includes(this.adatok.diakokszobahoz.find(dsz => dsz.diakid==f.id)?this.adatok.diakokszobahoz.find(dsz => dsz.diakid==f.id).szobaid:-2))
					&& (this.szures.csoportok.includes(-1) ? true : this.szures.csoportok.includes(this.adatok.diakokcsoporthoz.find(dcs => dcs.diakid==f.id)?this.adatok.diakokcsoporthoz.find(dcs => dcs.diakid==f.id).csoportid:-2))).map(d => {
						var szilenciumok = {};
						var termek = {};

						var minosites = this.adatok.minositesek.find(m => m.id==d.minosites);
						var csoport = this.adatok.diakokcsoporthoz.find(dcs => dcs.diakid==d.id) ? this.adatok.csoportok.find(cs => cs.id==this.adatok.diakokcsoporthoz.find(dcs => dcs.diakid==d.id).csoportid) : false
						var foglalasmegjegyzesek = {}
						var foglalasok = this.adatok.szilenciumfoglalas.filter(szf => {
							if(szf.foglaltnap==this.hettetszolegesnapja(this.szures.nap)&&((szf.foglalasmerteke==0)||(csoport ? szf.foglalasmerteke==1&&szf.foglaltid==csoport.id : false)||(szf.foglalasmerteke==2&&szf.foglaltid==d.id))) {
								foglalasmegjegyzesek['fsz'+szf.foglaltszilenciumid] = "("+(szf.foglalasmerteke==0 ? "Teljes kollégium" : (szf.foglalasmerteke==1 ? csoport.csoportnev : d.nev))+")"+(szf.foglalasmegjegyzes ? " - "+szf.foglalasmegjegyzes:"")+" - Foglaló: "+this.adatok.felhasznalok.find(f => f.id==szf.foglaloid).nev;
							}
							return szf.foglaltnap==this.hettetszolegesnapja(this.szures.nap)&&((szf.foglalasmerteke==0)||(csoport ? szf.foglalasmerteke==1&&szf.foglaltid==csoport.id : false)||(szf.foglalasmerteke==2&&szf.foglaltid==d.id))
						});
						this.adatok.szilenciumok.forEach(sz => {
							const bsz = this.adatok.bejegyzettszilenciumok.find(bsz => bsz.tanuloid==d.id&&bsz.nap==this.hettetszolegesnapja(this.szures.nap)&&bsz.szilenciumid==sz.id)
							szilenciumok["sz"+sz.id] = foglalasok.find(f => f.foglaltszilenciumid==sz.id) ? -2 : (bsz ? bsz.neveloibejegyzes : -1);
							if(bsz) termek["tsz"+sz.id]=this.adatok.termek.find(t => t.id==bsz.teremid) ?this.adatok.termek.find(t => t.id==bsz.teremid).nev:``;
						})

						return {
							id: d.id,
							nev: d.nev,
							szoba: this.adatok.diakokszobahoz.find(dsz => dsz.diakid==d.id) ? this.adatok.szobak.find(sz => sz.id==this.adatok.diakokszobahoz.find(dsz => dsz.diakid==d.id).szobaid).szobanev : "-",
							csoportnev: csoport ? csoport.csoportnev : false,
							csoportvezeto: csoport ? this.adatok.felhasznalok.find(f => f.id==csoport.csoportvezetoid).nev : false,
							szilenciumvalasztas: minosites.szilenciumvalasztas==1,
							szilenciumiletszambaszamit: minosites.szilenciumiletszambaszamit==1,
							minosites: minosites.minositesnev,
							...szilenciumok,
							...foglalasmegjegyzesek,
							...termek
						}
					})
			}
		},
		watch: {

		},
		methods: {
			jelenletmodositas: function(tanuloid,napsorszam,szilenciumid) {
				var nap = this.hettetszolegesnapja(napsorszam);
				var szilenciumbejegyzes=this.adatok.bejegyzettszilenciumok.find(szb => szb.tanuloid==tanuloid&&szb.nap==nap&&szb.szilenciumid==szilenciumid);
				var ujbejegyzes = szilenciumbejegyzes.neveloibejegyzes == 1 ? 0 : (szilenciumbejegyzes.neveloibejegyzes == 0 ? 2 : 1);
				this.axios.post(this.$store.state.backendeleres+"szilenciumbejegyzesek/jelenletvaltoztatas",{neveloibejegyzes: ujbejegyzes, nap, tanuloid, szilenciumid})
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) szilenciumbejegyzes.neveloibejegyzes=ujbejegyzes;
									})
			},
			tablazatfrissitese: function() {
        this.axios.get(this.$store.state.backendeleres+"szilenciumbejegyzesek/nevelotanar/"+this.hetfovalaszto.datum)
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) this.adatok=response.data.adatok;
										//this.adatok.csoportok.push({id: -1, csoportnev: "- Mind", csoportvezetoid: -1})
										//this.adatok.szobak.push({id: -1, szobanev: "Mind"})
										this.adatok.csoportok = [{id: -1, csoportnev: "Mind", csoportvezetoid: -1}].concat(this.adatok.csoportok)
										this.adatok.szobak = [{id: -1, szobanev: "Mind"}].concat(this.adatok.szobak)
										this.adatok.termek = [{id: -1, teremnev: "Mind"}].concat(this.adatok.termek);
										/*this.adatok.csoportok.sort((a,b) => {
											if(a.csoportnev<b.csoportnev) return -1
											if(b.csoportnev<a.csoportnev) return 1;
											return 0;
										})
										this.adatok.szobak.sort((a,b) => {
											if(a.szobanev<b.szobanev) return -1
											if(b.szobanev<a.szobanev) return 1;
											return 0;
										})*/
										this.tablazatmutat=true;
                  })
			},
			aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
			hetfok: nap => new Date(Date.parse(nap)).getDay()==1,
			nemhetvege: nap => new Date(Date.parse(nap)).getDay()<5&&new Date(Date.parse(nap)).getDay()>0,
			hettetszolegesnapja: function(nap /*0: hétfő, 1: kedd*/)  {
				var datum = new Date(Date.parse(this.hetfovalaszto.datum))
				datum.setDate(datum.getDate()+nap)
				return datum.toISOString().substring(0,10)
			}
		},
		mounted(){
			this.tablazatfrissitese()
		}
	}
</script>
